import { Checkbox, FormControlLabel, FormGroup, MenuItem, Select } from '@mui/material';
import { WATERFALL_MODEL } from 'common/constants/allocations';
import { BREAKPOINT_ANALYSIS_TITLE, CAP_TABLE_TITLE, CASH_FLOW_LEDGER_TITLE, FUND_OWNERSHIP_TITLE } from 'common/constants/cap-table';
import { COMPANIES_SUMMARY_TITLE } from 'common/constants/companies';
import { DOCUMENTS_TITLE } from 'common/constants/documents';
import { FINANCIAL_TITLE } from 'common/constants/financials';
import { VALUATIONS_TITLE } from 'common/constants/valuations';
import {
  StyledCheckboxRow,
  StyledFormControl,
  StyledSubOptionsContainer,
} from '../../BaseExcelExportDialog/BaseExcelExportDialog.styles';
import { EXPORT_OPTIONS } from '../CompanyExcelExportDialog.types';
import { OtherOptionsRendererProps } from './OtherOptionsRenderer.props';

export const OtherOptionsRenderer = ({
  currentSelectedOption,
  otherOptions,
  selectedVersions,
  hasSummary,
  hasDocuments,
  captables,
  financials,
  valuations,
  onOtherOptionChange,
  onOtherVersionChange,
}: OtherOptionsRendererProps) => {
  if (currentSelectedOption !== EXPORT_OPTIONS.OTHER) {
    return null;
  }

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={otherOptions.summary}
              onChange={() => onOtherOptionChange('summary')}
              disabled={!hasSummary}
            />
          }
          label={COMPANIES_SUMMARY_TITLE}
        />
        <StyledCheckboxRow>
          <FormControlLabel
            control={
              <Checkbox
                checked={otherOptions.capTable}
                onChange={() => onOtherOptionChange('capTable')}
                disabled={captables.length === 0}
              />
            }
            label={CAP_TABLE_TITLE}
          />
          <StyledFormControl size="small">
            <Select
              value={selectedVersions.capTable || ''}
              onChange={e => onOtherVersionChange('capTable', e.target.value as number)}
              disabled={captables.length === 0 || !otherOptions.capTable}>
              {captables.map(capTable => (
                <MenuItem key={capTable.id} value={capTable.id}>
                  {capTable.name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </StyledCheckboxRow>
        <FormControlLabel
          control={
            <Checkbox checked={otherOptions.fundOwnership}
              onChange={() => onOtherOptionChange('fundOwnership')}
              disabled={captables.length === 0}
            />
          }
          label={FUND_OWNERSHIP_TITLE}
        />
        <StyledCheckboxRow>
          <FormControlLabel
            control={
              <Checkbox
                checked={otherOptions.cashFlowLedger}
                onChange={() => onOtherOptionChange('cashFlowLedger')}
                disabled={captables.length === 0}
              />
            }
            label={CASH_FLOW_LEDGER_TITLE}
          />
          <StyledFormControl size="small">
            <Select
              value={selectedVersions.cashFlowLedger || ''}
              onChange={e => onOtherVersionChange('cashFlowLedger', e.target.value as number)}
              disabled={captables.length === 0 || !otherOptions.cashFlowLedger}>
              {captables.map(capTable => (
                <MenuItem key={capTable.id} value={capTable.id}>
                  {capTable.name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </StyledCheckboxRow>
        <FormControlLabel
          control={
            <Checkbox
              checked={otherOptions.breakpointAnalysis}
              onChange={() => onOtherOptionChange('breakpointAnalysis')}
              disabled={captables.length === 0}
            />
          }
          label={BREAKPOINT_ANALYSIS_TITLE}
        />
        <StyledCheckboxRow>
          <FormControlLabel
            control={
              <Checkbox
                checked={otherOptions.waterfallModel}
                onChange={() => onOtherOptionChange('waterfallModel')}
                disabled={captables.length === 0}
              />
            }
            label={WATERFALL_MODEL}
          />
          <StyledFormControl size="small">
            <Select
              value={selectedVersions.waterfallModel || ''}
              onChange={e => onOtherVersionChange('waterfallModel', e.target.value as number)}
              disabled={captables.length === 0 || !otherOptions.waterfallModel}>
              {captables.map(capTable => (
                <MenuItem key={capTable.id} value={capTable.id}>
                  {capTable.name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </StyledCheckboxRow>
        <StyledCheckboxRow>
          <FormControlLabel
            control={
              <Checkbox
                checked={otherOptions.financials}
                onChange={() => onOtherOptionChange('financials')}
                disabled={financials.length === 0}
              />
            }
            label={FINANCIAL_TITLE}
          />
          <StyledFormControl size="small">
            <Select
              value={selectedVersions.financials || ''}
              onChange={e => onOtherVersionChange('financials', e.target.value as number)}
              disabled={financials.length === 0 || !otherOptions.financials}>
              {financials.map(financial => (
                <MenuItem key={financial.id} value={financial.id}>
                  {financial.name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        </StyledCheckboxRow>
        <FormControlLabel
          control={
            <Checkbox
              checked={otherOptions.valuations}
              onChange={() => onOtherOptionChange('valuations')}
              disabled={valuations.length === 0}
            />
          }
          label={VALUATIONS_TITLE}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={otherOptions.documents}
              onChange={() => onOtherOptionChange('documents')}
              disabled={!hasDocuments}
            />
          }
          label={DOCUMENTS_TITLE}
        />
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
